import { render } from "./IOSWarning.vue?vue&type=template&id=128a586e"
import script from "./IOSWarning.vue?vue&type=script&lang=js"
export * from "./IOSWarning.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__